import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { EventsAwardsLandingPageContext } from "@events-awards/utils/types";
import { Route } from "@route-types/Section/layouts/EventsAwards/E50/+types/EventsAwardsE50Page";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import { fetchEventsAwardsE50PageData } from "./EventsAwardsE50Page.server";
import EventsAwardsE50PageContent from "./EventsAwardsE50PageContent";

/** This is the main entry point component for /events-awards/enterprise-50 route. */
const EventsAwardsE50Page = (): React.ReactElement => {
  const context = useLoaderData<EventsAwardsLandingPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <EventsAwardsE50PageContent {...context.payload.data} />;
};

export default EventsAwardsE50Page;

export const loader = async () => await fetchEventsAwardsE50PageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as EventsAwardsLandingPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
